angular.module('picmonicng').component('homePracticeQuestions', {
  templateUrl: '/templates/app/components/home-practice-questions/home-practice-questions.html',
  bindings: {},
  controller: [
    'PQService',
    function (PQService) {
      var $ctrl = this;
      $ctrl.PQService = PQService;
    },
  ],
});
